<template>
	<div>
		<Game v-if="currentData" :currentPlayer="currentPlayer" :currentData="currentData" :settings="settings" v-on:nextStep="nextStep" />
	</div>
</template>

<script>
import Game from "@/components/Game.vue";
export default {
	components: {
		Game,
	},
	data() {
		return {
			settings: {
				wordsPerGame: this.$store.state.gamemode == 2? 5 : 10,
				timeout: 60,
				preCount: 15,
			},
			data: this.$store.state.dictionary,
			used: [],
			wordData: false,
			currentPlayer: 0,
			currentData: false,
		};
	},
	methods: {
		random(max) {
			if (max <= 2) return 0;
			let random = Math.floor(Math.random() * max);
			if (this.used.includes(random)) {
				return Math.floor(this.random(max));
			} else {
				this.used.push(random);
				return Math.floor(random);
			}
		},
		nextStep(currentWord, score, guessedWords) {
			this.$store.state.players[this.currentPlayer]["score"] = score;
			this.$store.state.players[this.currentPlayer]["guessedWords"] = guessedWords;

			if (currentWord + 1 == this.settings.wordsPerGame && this.currentPlayer == this.$store.state.players.length - 1) {
				this.$store.state.endGame = true;
			} else {
				this.$store.state.players[this.currentPlayer]["currentWord"] = currentWord + 1;
				this.wordData = this.$store.state.players[this.currentPlayer]["wordsData"][currentWord + 1];

				let nextPlayer = this.currentPlayer + 1;
				if (this.$store.state.players[nextPlayer] == undefined) {
					this.currentPlayer = 0;
				} else {
					this.currentPlayer = nextPlayer;
				}

				switch (this.currentPlayer) {
					case 0:
						this.$store.state.players[this.currentPlayer]["color"] = "orange";
						break;

					case 1:
						this.$store.state.players[this.currentPlayer]["color"] = "pink";
						break;
				}

				this.currentData = this.$store.state.players[this.currentPlayer];
			}
		},
	},
	mounted() {
		if (!this.$store.state.dictionary) {
			this.$router.push("/");
		}

		let players = [];

		for (let i = 0; i < this.$store.state.gamemode; i++) {
			let words = [];

			players[i] = {
				countHints: 0,
				currentWord: 0,
				guessedWords: 0,
				hints: [],
				letter: false,
				score: 0,
				startGame: false,
				startPrecount: false,
				status: false,
				synonym: false,
				used: [],
				wordData: false,
				wordScore: 0,
				wordsData: [],
			};

			for (let i = 0; i < this.settings.wordsPerGame; i++) {
				let word = this.$store.state.dictionary[this.random(this.$store.state.dictionary.length)];
				words.push(word);
			}

			/* Soluzione */
			console.log("Squadra " + (i + 1));
			words.map((el) => {
				console.log(el.word);
			}); 
			/* Fine soluzione */

			this.updateProperty({
				property: "backgroundColor",
				value: "orange",
			});

			players[i]["wordsData"] = words;
			players[i]["wordData"] = players[i]["wordsData"][players[i]["currentWord"]];
		}
	
		if (players[0]) {
			players[0]["color"] = "orange";
			players[0]["name"] = "Rosa";
		}

		if (players[1]) {
			players[1]["color"] = "pink";
			players[1]["name"] = "Fucsia";
		}

		this.$store.state.players = players;
		this.$store.state.sounds.intro.pause();
		this.$store.state.sounds.soundtrack.currentTime = 0;

		this.currentData = this.$store.state.players[this.currentPlayer];
	},
};
</script>
